var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommitment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    "data-name": "Rectangle 1729",
    width: 17.929,
    height: 22.584,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_5:_Commitment",
    "data-name": "Stage 5: Commitment",
    transform: "translate(-592.108 -302.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_684",
    "data-name": "Ellipse 684",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592.108 302.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32059",
    "data-name": "Group 32059",
    transform: "translate(597.144 305.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32058",
    "data-name": "Group 32058",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13524",
    "data-name": "Path 13524",
    d: "M9.881,4.684l.093-.077,2.5-2.085c.01-.009.018-.02.027-.029l.026-.024a.549.549,0,0,0,.122-.231V2.217l.011-.054q0-.032,0-.063V2.085a.5.5,0,0,0-.084-.255V1.822L11.513.231a.535.535,0,0,0-.332-.222A.485.485,0,0,0,11.029,0H6.848A.527.527,0,0,0,6.41.236L5.353,1.822V1.83a.5.5,0,0,0-.084.255V2.1a.332.332,0,0,0,0,.063.517.517,0,0,1,.011.054v.021a.538.538,0,0,0,.122.231l.026.024a.357.357,0,0,0,.027.029L7.81,4.483l.237.2a8.974,8.974,0,0,0,.908,17.9h0a8.974,8.974,0,0,0,.926-17.9m-.915,15.94H8.959a7.016,7.016,0,0,1,0-14.032h.009a7.016,7.016,0,0,1,0,14.032",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment);
export default __webpack_public_path__ + "static/media/commitment.684827e146d7e0731cafe11999380d8c.svg";
export { ForwardRef as ReactComponent };